import { useState, useEffect, useMemo, useContext } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useLocation } from "react-router-dom";

import EmailHeader from "../../components/tickets/Email/History/EmailHeader";
import EmailTabs from "../../components/tickets/Email/History/EmailTabs";

import EmailHistory from "../../components/tickets/Email/History";
import EmailDetails from "../../components/tickets/Email/Details";
import { Http, appLogger } from "../../utils";
import { UserLoginInfo } from "../../types/context";
import { UserContext } from "../../context/userContext";
import { IFeedbackAgentSettings } from "../../model";

const Tickets = () => {
  const location = useLocation();

  const initialTabValue = useMemo(() => {
    if (location?.state?.tab) {
      return location?.state?.tab;
    }
    return 0;
  }, [location]);

  const [selectedTicket, setSelectedTicket] = useState<number | null>(null);
  const [tab, setTab] = useState(initialTabValue);
  const [feedbackData, setFeedbackData] = useState<
    IFeedbackAgentSettings | undefined
  >(location.state.feedbackData);
  const [topic, settopic] = useState<string>(location.state.topic);
  const { userInfo } = useContext(UserContext) as UserLoginInfo;

  // useEffect(() => {
  //   Http.get({
  //     url: `/api/v2/userFeedback?id=${location.state.feedbackId}`,
  //     state: userInfo,
  //   }).then((response: any) => {
  //     appLogger.info({
  //       infoObj: {
  //         method: "useEffect",
  //         component: "add-products",
  //         fileName: "index.tsx",
  //         productResponse: response,
  //       },
  //     });
  //     setFeedbackData(response.Items[0]);
  //   }).catch((error: any) => {
  //     appLogger.error({
  //       errObj: {
  //         method: "useEffect",
  //         component: "add-products",
  //         fileName: "index.tsx",
  //         err: error,
  //       },
  //     });
  //     // setFailure(true);
  //   });
  // });

  const handleChangeTab = (event: any, newValue: number) => {
    setTab(newValue);
  };

  const handleSelectTicket = (id: number) => {
    setSelectedTicket(id);
  };

  return (
    <Box>
      <EmailHeader feedbackData={feedbackData} topic={topic} />
      <EmailTabs tab={tab} handleChangeTab={handleChangeTab} />
      {tab === 0 && <EmailDetails feedbackData={feedbackData} topic={topic} />}
      {tab === 1 && (
        <EmailHistory
          selectedTicket={selectedTicket}
          handleSelectTicket={handleSelectTicket}
        />
      )}
    </Box>
  );
};
export default Tickets;
